import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin, ArrowRight } from "lucide-react";

const serviceLinks = [
  { label: "Screen Printing Dallas", to: "/services/screen-printing" },
  { label: "DTF Printing Dallas", to: "/services/dtf-printing" },
  { label: "Embroidery Dallas", to: "/services/embroidery" },
  { label: "Custom Jerseys Dallas", to: "/services/custom-jerseys" },
  { label: "Graphic Design", to: "/services/graphic-design" },
  { label: "Specialty Printing", to: "/services/specialty-printing" },
];

const cityLinks = [
  "Dallas", "Fort Worth", "Arlington", "Plano", "Irving", "Garland",
  "Frisco", "McKinney", "Allen", "Carrollton", "Mesquite", "Grand Prairie",
  "Richardson", "Denton", "Lewisville", "Flower Mound",
];

const quickLinks = [
  { label: "Pricing Guide", to: "/pricing" },
  { label: "Product Catalog", to: "/product-catalog" },
  { label: "Team Store", to: "/team-store" },
  { label: "Rush Orders", to: "/contact" },
  { label: "Bulk Discounts", to: "/pricing" },
  { label: "Service Area", to: "/service-area" },
  { label: "Blog", to: "/blog" },
  { label: "About Us", to: "/about" },
  { label: "Get a Quote", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-neutral-800">
      {/* CTA Banner */}
      <div className="bg-red-700 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-teko text-2xl text-white uppercase tracking-wide">Ready to Order Custom Apparel?</p>
            <p className="text-red-200 text-sm font-inter">Free quote within 2 hours. Free DFW delivery on 24+ pieces.</p>
          </div>
          <Link
            to="/contact"
            data-testid="footer-cta-btn"
            className="flex items-center gap-2 bg-white text-red-700 hover:bg-neutral-100 font-bold uppercase tracking-widest px-8 py-3 font-teko text-lg transition-colors shrink-0"
          >
            GET A FREE QUOTE <ArrowRight size={16} />
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_419da4a4-c2d8-43a0-81d2-8591121c3d6f/artifacts/vrml7tge_ninjascreenprintlogo.png"
                alt="Ninja Screen Print - Dallas, TX"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-neutral-400 text-sm font-inter leading-relaxed mb-6">
              Dallas's premier screen printing company. Custom apparel for DFW businesses, schools, sports teams, and events. Mastery in ink, precision in print.
            </p>
            <div className="space-y-2">
              <a href="tel:+12145550190" data-testid="footer-phone" className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors">
                <Phone size={14} className="text-red-500" />
                <span className="font-inter">(214) 555-0190</span>
              </a>
              <a href="mailto:orders@ninjascreenprint.com" data-testid="footer-email" className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors">
                <Mail size={14} className="text-red-500" />
                <span className="font-inter">orders@ninjascreenprint.com</span>
              </a>
              <div className="flex items-start gap-2 text-sm text-neutral-400">
                <MapPin size={14} className="text-red-500 mt-0.5 shrink-0" />
                <span className="font-inter">Dallas, TX (Serving all DFW)</span>
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <a href="https://instagram.com/ninjascreenprint" aria-label="Instagram" className="w-8 h-8 border border-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white hover:border-red-500 transition-colors">
                <Instagram size={14} />
              </a>
              <a href="https://facebook.com/ninjascreenprint" aria-label="Facebook" className="w-8 h-8 border border-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white hover:border-red-500 transition-colors">
                <Facebook size={14} />
              </a>
              <a href="https://linkedin.com/company/ninjascreenprint" aria-label="LinkedIn" className="w-8 h-8 border border-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white hover:border-red-500 transition-colors">
                <Linkedin size={14} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="font-teko text-lg uppercase tracking-widest text-white mb-4">Our Services</h3>
            <div className="w-8 h-px bg-red-600 mb-5" />
            <ul className="space-y-2">
              {serviceLinks.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="text-sm text-neutral-400 hover:text-red-400 transition-colors font-inter flex items-center gap-1 group"
                  >
                    <ArrowRight size={10} className="text-red-600 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-teko text-lg uppercase tracking-widest text-white mb-4">Quick Links</h3>
            <div className="w-8 h-px bg-red-600 mb-5" />
            <ul className="space-y-2">
              {quickLinks.map((l) => (
                <li key={l.to + l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-neutral-400 hover:text-red-400 transition-colors font-inter flex items-center gap-1 group"
                  >
                    <ArrowRight size={10} className="text-red-600 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-teko text-lg uppercase tracking-widest text-white mb-4">DFW Service Area</h3>
            <div className="w-8 h-px bg-red-600 mb-5" />
            <p className="text-xs text-neutral-500 font-inter mb-3">Serving custom apparel orders across the entire DFW Metroplex:</p>
            <div className="flex flex-wrap gap-1">
              {cityLinks.map((city) => (
                <Link
                  key={city}
                  to="/service-area"
                  className="text-xs text-neutral-400 hover:text-red-400 transition-colors font-inter px-2 py-0.5 border border-neutral-800 hover:border-red-900"
                >
                  {city}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* SEO Text Block */}
        <div className="mt-12 pt-8 border-t border-neutral-800">
          <p className="text-xs text-neutral-600 font-inter leading-relaxed text-center max-w-4xl mx-auto">
            Ninja Screen Print is Dallas's premier custom apparel printing company, proudly serving the entire DFW Metroplex including Dallas, Fort Worth, Arlington, Plano, Irving, Garland, Frisco, McKinney, Allen, Carrollton, Mesquite, Grand Prairie, Richardson, Denton, and surrounding communities. We specialize in screen printing, DTF printing, embroidery, custom jerseys, graphic design, and specialty printing for businesses, schools, sports teams, restaurants, healthcare providers, churches, nonprofits, and events of all sizes throughout North Texas.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-neutral-600 font-inter">
          <p>© {new Date().getFullYear()} Ninja Screen Print — Dallas, TX. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/about" className="hover:text-neutral-400 transition-colors">Privacy Policy</Link>
            <Link to="/about" className="hover:text-neutral-400 transition-colors">Terms of Service</Link>
            <Link to="/sitemap.xml" className="hover:text-neutral-400 transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>

      {/* Mobile Sticky CTA */}
      <div className="lg:hidden mobile-sticky-cta">
        <Link
          to="/contact"
          data-testid="mobile-sticky-cta"
          className="flex items-center justify-center gap-2 bg-red-600 text-white py-4 font-teko text-lg tracking-widest uppercase"
        >
          <Phone size={16} /> GET A FREE QUOTE
        </Link>
      </div>
    </footer>
  );
}
